export default __webpack_public_path__ + "static/media/Union.2c3d795a.svg";